import {
  IsNotEmpty,
  IsOptional,
  IsArray,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { IAdapterRemoveFolderRefAction } from "./adapter-remove-folder-ref-action.interface";
import { QueryDto } from "../query";

/** Actions for setting work completion percentage on a workorder or its operations, resources, assignments... */
export class AdapterRemoveFolderRefActionDto
  implements IAdapterRemoveFolderRefAction
{
  @IsNotEmpty()
  entity_name: string; // In case of SAP => 'workorder' | 'operation' | 'assignment'

  @IsOptional()
  @IsArray()
  entity_ids?: string[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;
}
